
import React from "react";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import Body from "../../ui/Body"
import Banks from "./Banks";

function BankDetails() {
    // theme context
    return (
        <>
            <Sidebar />
            <Nabvar />
            <Body >
                <Banks />
            </Body>
        </>
    );
}

export default BankDetails
